import { useEffect, useRef } from 'react';

function InArticleAd() {
  var adRef = useRef(null);
  var pushed = useRef(false);

  useEffect(function () {
    if (adRef.current && !pushed.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) {}
    }
  }, []);

  return (
    <div className="in-article-ad">
      <ins
        className="adsbygoogle"
        ref={adRef}
        style={{ display: 'block', textAlign: 'center' }}
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client="ca-pub-4636071260060895"
        data-ad-slot="3396279204"
      />
    </div>
  );
}

export default InArticleAd;
